import {noop} from 'lodash';
import React, {FC} from 'react';
import {connect} from 'react-redux';

import {useAppQuery} from '../../../libs/shared/core/src/services/query/useAppQuery';
import {InboxesPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../srcCommon/helpers/reselectHelpers';
import {rulesComplexTemplatesQueries} from '../../queries/rulesComplexTemplates';
import {AppState} from '../../store/appState';
import {setAiTaggingHarvestingRuleBundleId} from '../../store/panels/inboxes/inboxesPanelActions';
import {makeGetInboxesPanel} from '../../store/panels/inboxes/inboxesPanelSelectors';
import {AiReviewHarvestingModal} from './aiHarvestingModal';

/*
 * Props.
 */

interface AiHarvestingModalContainerProps {
  panelId: InboxesPanelId;
}

interface AiHarvestingModalComponentProps {
  panelId: InboxesPanelId;
  ruleBundleId: number | undefined;
  onCancel: () => void;
}

/*
 * Selectors.
 */

function getPanelId(_state: AppState, props: AiHarvestingModalContainerProps) {
  return props.panelId;
}

function makeGetAiHarvestingModalRuleBundleId() {
  const getInboxesPanel = makeGetInboxesPanel(getPanelId);
  return createSelector([getInboxesPanel], (panel) => panel.aiTaggingHarvestingReviewRuleBundleId);
}

/*
 * Component.
 */

const AiReviewHarvestingModalComponent: FC<AiHarvestingModalComponentProps> = (props) => {
  const {ruleBundleId, onCancel} = props;

  // Data fetching.
  const {data: aiTaggingDefinition} = useAppQuery({
    ...rulesComplexTemplatesQueries.getAiTaggingTemplateByBundleId(ruleBundleId),
    enabled: ruleBundleId !== undefined,
  });

  if (!ruleBundleId) {
    return null;
  }

  return (
    <AiReviewHarvestingModal
      onCancel={onCancel}
      // Function only relevant when modal lives in the AI Tagging editor so noop is fine here.
      onReviewSuccessData={noop}
      ruleBundleId={ruleBundleId}
      aiTaggingDefinition={aiTaggingDefinition}
    />
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<AiHarvestingModalContainerProps>()(() => ({
  ruleBundleId: makeGetAiHarvestingModalRuleBundleId(),
}));

const mapDispatchToProps = makeMapDispatchToProps<AiHarvestingModalContainerProps>()(() => ({
  onCancel: () => setAiTaggingHarvestingRuleBundleId(undefined),
}));

export const AiReviewHarvestingModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AiReviewHarvestingModalComponent);
